module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "flourish",
      "src": "images/flourish.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('span', {
    staticClass: "s3"
  }, [_vm._v("I")]), _vm._v(" want to thank my beta readers—Toni Echols, Marliss Melton, and PR. This was a better story because of all your input. And I offer my undying gratitude to my editor, Chloe Bearuski, who as usual infused my writing with her grace and composure.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b97ae2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section5.vue
// module id = 72
// module chunks = 0